// extracted by mini-css-extract-plugin
export default {"root":"InfoTiles_root__MqVcb","value":"InfoTiles_value__5FGOO","description":"InfoTiles_description__11kDd"};